import jump from 'jump.js';
import Component from '../../../scripts/utilities/component';

class ScollToSection extends Component {
    componentDidMount() {
        const maxWidth = 1023;
        this.smallValue = -70;
        this.largeValue = -140;
        this.mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
        this.scrollOffset = window.innerWidth < maxWidth ? this.smallValue : this.largeValue;
        this.links = [...this.root.querySelectorAll('[data-ref="scroll-link"]')];

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.links.forEach((link) => {
            link.addEventListener('click', this.handleClick.bind(this), true);
        });

        this.mq.addListener((mql) => {
            if (mql.matches) {
                this.scrollOffset = this.smallValue;
            } else {
                this.scrollOffset = this.largeValue;
            }
        });
    }

    handleClick(e) {
        e.preventDefault();
        const target = `#${e.target.getAttribute('data-target')}`;

        jump(target, {
            offset: this.scrollOffset
        });
    }
}

export default ScollToSection;



// WEBPACK FOOTER //
// ./components/eng-ms-squad-links/scripts/scroll-to-section.js